import { render, staticRenderFns } from "./JTMSCourseLicenseTemplate.vue?vue&type=template&id=f50db1ec&"
import script from "./JTMSCourseLicenseTemplate.vue?vue&type=script&lang=ts&"
export * from "./JTMSCourseLicenseTemplate.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports